import React, { useLayoutEffect, useContext } from 'react';
import { UptimeModal, UptimeGeneralDialog, HlxButton } from '@uptime/uptime-component';
import { useTranslation } from 'react-i18next';
import UserService from 'services/userServices';
import { ModalProps } from '../../ModalProps';
import { Grid } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import { StyledIcon } from '../../../utils/icon.style';
import { PORTAL_NAME, PORTAL_VERSION } from 'constants/index';
import { ThemeContext } from 'styled-components';
import { ContentDescription } from './LogoutModal.style';
import { useUserData } from 'hooks';
import {msalInstance} from 'config/auth';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

export type LogoutModalProps = ModalProps;

const LogoutModal: React.FC<LogoutModalProps> = props => {
  const currentUser = useUserData();
  const { t } = useTranslation(['topNav', 'generalDialog']);
  const theme = useContext(ThemeContext);
  const { generalConfig } = useSelector((state: RootState) => state.configReducer);
  useLayoutEffect(() => {
    UptimeModal.setAppElement('body');
  });
  let dataUser: any = currentUser;

  function onClickSignOut() {
    (async () => {
      const res = await UserService.clearAllByUser(dataUser.user_name);
      if (props.signOutFC && res?.status === 200) {
        props.signOutFC();
      }
      if (!msalInstance) return;

      msalInstance.logoutRedirect().catch((e: any) => {
        console.error(e);
      })
      const currentVersion = localStorage.getItem(PORTAL_VERSION) || '';
      localStorage.clear();
      localStorage.setItem(PORTAL_VERSION, currentVersion);
    })();
  }

  const content = (
    <Grid item container direction="column" alignItems='center'>
      <StyledIcon
        styleIcon={{
          fontSize: theme.uptimeFontSizes.desktop.fz11,
          color: theme.uptimeColors.generalColors.state.warning,
        }}
      >
        <ErrorIcon />
      </StyledIcon>
      <ContentDescription>{t('topNav:logOutMessage', { portalName: generalConfig?.portalName || PORTAL_NAME })}</ContentDescription>
    </Grid>
  );

  const buttonSubmit = (
    <>
      <HlxButton
        label={t('topNav:signOut')}
        onClick={() => onClickSignOut()}
      />
    </>
  );

  return (
    <UptimeGeneralDialog
      title={t('topNav:signOut')}
      content={content}
      isOpen={props.isModalOpen}
      buttonSubmit={buttonSubmit}
      handleClose={() => {
        props.setIsModalOpen(false);
      }}
      showComment={false}
      deviders={false}
      headerBackgroundDefault={false}
      cancelLabel={t("generalDialog:cancel")}
      commonStyles={{ width: '480px', zIndex: 1400 }}
      justifyContentAction='center'
    />
  );
};

export default LogoutModal;
